/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  InterruptTurnRequestBody,
  InterruptTurnRequestBody$Outbound,
  InterruptTurnRequestBody$outboundSchema,
} from "../components/interruptturnrequestbody.js";

export type InterruptAssistantTurnSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type InterruptAssistantTurnRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  interruptTurnRequestBody: InterruptTurnRequestBody;
};

/** @internal */
export type InterruptAssistantTurnSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const InterruptAssistantTurnSecurity$outboundSchema: z.ZodMiniType<
  InterruptAssistantTurnSecurity$Outbound,
  InterruptAssistantTurnSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function interruptAssistantTurnSecurityToJSON(
  interruptAssistantTurnSecurity: InterruptAssistantTurnSecurity,
): string {
  return JSON.stringify(
    InterruptAssistantTurnSecurity$outboundSchema.parse(
      interruptAssistantTurnSecurity,
    ),
  );
}

/** @internal */
export type InterruptAssistantTurnRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  InterruptTurnRequestBody: InterruptTurnRequestBody$Outbound;
};

/** @internal */
export const InterruptAssistantTurnRequest$outboundSchema: z.ZodMiniType<
  InterruptAssistantTurnRequest$Outbound,
  InterruptAssistantTurnRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    interruptTurnRequestBody: InterruptTurnRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      interruptTurnRequestBody: "InterruptTurnRequestBody",
    });
  }),
);

export function interruptAssistantTurnRequestToJSON(
  interruptAssistantTurnRequest: InterruptAssistantTurnRequest,
): string {
  return JSON.stringify(
    InterruptAssistantTurnRequest$outboundSchema.parse(
      interruptAssistantTurnRequest,
    ),
  );
}
